import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import EnsureLoggedInContainer from '@/components/EnsureLoggedIn/EnsureLoggedInContainer';
import { savedSearchItemSortOrders, sellerSortOrders } from '@/enums';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';
import { parseQueryParams, validateQueryParams } from '@/utils/queryParams';

import ForYouPage from '../ForYouPage/ForYouPage';

type QueryParams = {
    keyword: string;
    page: string;
    pageSize: string;
    sort: string;
    tab: 'searches' | 'items';
};

const ForYouPageContainer = () => {
    const navigate = useNavigate();
    const { pathname, search } = useLocation();
    const queryParams = parseQueryParams<QueryParams>(search);
    const tab = pathname.split('/')[2];
    const baseUrl = useAppSelector(getBaseUrl);

    let validatedQueryParams: ReturnType<typeof validateQueryParams>;
    if (tab === 'followed-searches') {
        validatedQueryParams = validateQueryParams(queryParams, savedSearchItemSortOrders);
    } else if (tab === 'followed-auctioneers') {
        validatedQueryParams = validateQueryParams(queryParams, sellerSortOrders);
    } else if (tab === 'for-you') {
        validatedQueryParams = validateQueryParams(queryParams, savedSearchItemSortOrders);
    }

    const { page, sort } = validatedQueryParams || {};

    return (
        <EnsureLoggedInContainer>
            <ForYouPage
                baseUrl={baseUrl}
                page={page}
                pathname={pathname}
                pushNewUrl={navigate}
                sort={sort}
                tab={tab}
                terms={queryParams.keyword}
            />
        </EnsureLoggedInContainer>
    );
};

export default ForYouPageContainer;
